import { FC } from 'react';
import { Input, Pagination } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import TableAtom from 'components/atoms/TableAtom';
import { useClientProjectsList } from './resources/useClientProjectsList';
import { CustomProjectModel } from 'core/domain/project/model/projectModel';
import { TABLE_PAGE_SIZE_DEFAULT_OPTIONS, TABLE_PAGINATION_SIZE_DEFAULT } from 'constants/table';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import ProjectCreateModal from 'components/organisms/ProjectCreateModal';
import ConfirmModal from 'components/molecules/ConfirmModal';
import Paper from '../../../atoms/Paper';
import './styles.scss';

const MAX_SIZE_RESPONSIVE_SCREEN = 600;

const TabProjectsList: FC = () => {
  const {
    projects,
    projectsColumns,
    translations,
    currentPage,
    pageSize,
    totalPages,
    createProjectFormData,
    createProjectModalTranslations,
    deleteProjectModalTranslations,
    onChangePage,
    onSearch,
    onSelectProject,
    onOpenCreateProjectModal,
    onCloseCreateProjectModal,
    onDeleteProject,
    onCloseDeleteProjectModal,
    isUserSuperAdmin,
    isDeleteProjectModalVisible,
    isDeletingProject,
    loadingProjects,
    isCreateProjectModalVisible,
  } = useClientProjectsList();

  return (
    <>
      <Paper>
        <div className='TabProjects__buttons'>
          <Input.Search autoFocus allowClear placeholder={translations.searchPlaceholder} onSearch={onSearch} />
          <DefaultButton
            onClick={onOpenCreateProjectModal}
            icon={<PlusOutlined />}
            title={translations.createProjectButtonText}
            hidden={!isUserSuperAdmin}
          />
        </div>
        <TableAtom<CustomProjectModel>
          loading={loadingProjects}
          columns={projectsColumns}
          dataSource={projects}
          rowKey={'projectId'}
          pagination={false}
          scroll={{ x: MAX_SIZE_RESPONSIVE_SCREEN }}
          onRow={(item) => {
            return {
              onClick: () => onSelectProject(item),
            };
          }}
        />
        <Pagination
          className={'TabProjects__pagination'}
          size={'small'}
          showSizeChanger={true}
          defaultPageSize={Number(TABLE_PAGINATION_SIZE_DEFAULT)}
          pageSizeOptions={TABLE_PAGE_SIZE_DEFAULT_OPTIONS}
          current={currentPage}
          total={pageSize * totalPages}
          pageSize={pageSize}
          onChange={onChangePage}
        />
      </Paper>
      <ProjectCreateModal
        formData={createProjectFormData}
        translations={createProjectModalTranslations}
        open={isCreateProjectModalVisible}
        onCancel={onCloseCreateProjectModal}
      />
      <ConfirmModal
        title={deleteProjectModalTranslations.title}
        text={deleteProjectModalTranslations.text}
        mainButtonText={deleteProjectModalTranslations.mainButtonText}
        secondaryButtonText={deleteProjectModalTranslations.secondaryButtonText}
        onClickMainButton={onDeleteProject}
        onCancel={onCloseDeleteProjectModal}
        visible={isDeleteProjectModalVisible}
        loading={isDeletingProject}
      />
    </>
  );
};

export default TabProjectsList;
